import React from 'react';
import { Button, Modal, Text, Title } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { connect } from 'react-redux';
import { fubTexts } from "../../../../../constants";
import { selectBonusBalanceDescription, selectIsBonusBalanceModalOpen } from "../../../../../../../../store/selectors";
import { ConnectionBlockActionCreator } from "../../../../../store/actions";
import styles from "../styles.pcss";
var cn = classNames.bind(styles);
export var _BonusBalanceModal = function _BonusBalanceModal(_ref) {
  var isOpen = _ref.isOpen,
    text = _ref.text,
    onButtonClick = _ref.onButtonClick,
    onClose = _ref.onClose;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    portalClassName: cn('bonus-modal-portal'),
    theme: "dark",
    "data-t-id": "BalancesSelect-BonusBalanceModal"
  }, /*#__PURE__*/React.createElement(Title, {
    className: cn('bonus-modal-title'),
    size: "xl",
    title: fubTexts.bonusBalance.title,
    "data-t-id": "BalancesSelect-BonusBalanceModal"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('bonus-modal-container')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: "small"
  }, text)), /*#__PURE__*/React.createElement(Button, {
    onClick: onButtonClick,
    width: isMobile ? 'full' : 'default'
  }, fubTexts.bonusBalance.btnText));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isOpen: selectIsBonusBalanceModalOpen(state),
    text: selectBonusBalanceDescription(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onButtonClick: function onButtonClick() {
      dispatch(ConnectionBlockActionCreator.setOpenedModal('BalanceListModalAfterBonusBalanceModal'));
    },
    onClose: function onClose() {
      dispatch(ConnectionBlockActionCreator.setOpenedModal(null));
    }
  };
};
export var BonusBalanceModal = connect(mapStateToProps, mapDispatchToProps)(_BonusBalanceModal);